/* Local FAQ search and topic filters. No requests or form submissions. */
(() => {
  const controllers = new Map();
  const topicNames = {
    company: 'Our Maison', delivery: 'Delivery', returns: 'Exchange & Returns',
    gifting: 'Gifting', orders: 'Orders', jewelry: 'Jewelry', services: 'Services'
  };
  const normalize = value => value.normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

  function initialize(scope = document) {
    for (const [root, controller] of controllers) {
      if (!root.isConnected) controller.destroy();
    }
    const roots = [...scope.querySelectorAll('[data-brand-care]')];
    if (scope.matches?.('[data-brand-care]')) roots.unshift(scope);
    roots.forEach(root => {
      if (controllers.has(root)) return;
      const input = root.querySelector('[data-care-search]');
      const clear = root.querySelector('[data-care-clear]');
      const count = root.querySelector('[data-care-count]');
      const empty = root.querySelector('[data-care-empty]');
      const tools = root.querySelector('[data-care-search-tools]');
      const title = root.querySelector('#CareAnswersTitle');
      const filters = [...root.querySelectorAll('[data-care-filter]')];
      const questions = [...root.querySelectorAll('[data-care-question]')];
      if (!input || !clear || !count || !empty || !tools || !questions.length) return;
      const entries = questions.map(element => ({
        element, categories: element.dataset.careCategory.split(/\s+/),
        featured: element.dataset.careFeatured === 'true',
        searchable: normalize(element.textContent)
      }));
      const listeners = [];
      let category = 'featured';
      const listen = (element, type, handler) => {
        element.addEventListener(type, handler);
        listeners.push(() => element.removeEventListener(type, handler));
      };
      const apply = () => {
        const terms = normalize(input.value).split(/\s+/).filter(Boolean);
        let visible = 0;
        entries.forEach(({element, categories, featured, searchable}) => {
          const matches = (category === 'all' || (category === 'featured' ? featured : categories.includes(category)))
            && terms.every(term => searchable.includes(term) || normalize(element.textContent).includes(term) || normalize(window.EasternI18n?.bilingualText(element) || '').includes(term));
          element.hidden = !matches;
          if (!matches) element.open = false;
          if (matches) visible += 1;
        });
        filters.forEach(filter => {
          filter.setAttribute('aria-pressed', String(filter.dataset.careFilter === category));
          if (filter.dataset.careFilter === 'all') {
            filter.hidden = category === 'featured' || category === 'all';
          }
        });
        empty.hidden = visible !== 0;
        clear.disabled = input.value.length === 0;
        clear.hidden = clear.disabled;
        root.dataset.careMode = category;
        if (title) title.textContent = category === 'featured' ? 'Frequent Questions'
          : category === 'all' ? (terms.length ? 'Search Results' : 'All Questions') : topicNames[category];
        const label = visible === 1 ? 'question' : 'questions';
        count.textContent = `${visible} ${label}${terms.length ? ' found' : ''}`
          + (category === 'all' || category === 'featured' ? '' : ` · ${topicNames[category]}`);
      };
      const reset = (nextCategory = 'featured') => {
        input.value = '';
        category = nextCategory;
        apply();
      };
      const revealHash = () => {
        let id;
        try { id = decodeURIComponent(window.location.hash.slice(1)); }
        catch { return; }
        const target = questions.find(question => question.id === id);
        if (!target) return;
        reset('all');
        target.open = true;
        requestAnimationFrame(() => {
          if (!target.isConnected) return;
          target.querySelector('summary')?.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'start', behavior: 'auto' });
        });
      };
      listen(input, 'input', () => {
        category = normalize(input.value) ? 'all' : 'featured';
        apply();
      });
      listen(input, 'search', () => {
        category = normalize(input.value) ? 'all' : 'featured';
        apply();
      });
      listen(clear, 'click', () => {
        reset();
        input.focus();
      });
      filters.forEach(filter => {
        filter.disabled = false;
        listen(filter, 'click', () => {
          const selected = filter.dataset.careFilter;
          if (selected !== 'all' && !Object.hasOwn(topicNames, selected)) return;
          category = selected;
          input.value = '';
          apply();
        });
      });
      listen(window, 'hashchange', revealHash);
      tools.hidden = false;
      controllers.set(root, {destroy() {
        listeners.forEach(remove => remove());
        controllers.delete(root);
      }});
      apply();
      revealHash();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, controller] of controllers) {
      if (event.target === root || event.target.contains(root)) controller.destroy();
    }
  });
})();
